import Panel from '../panel'
import TeamNotesMetadata from './TeamNotesMetadata'
import TeamNotesButtons from './TeamNotesButtons'
import Textarea from '../ui-components/Textarea'
import classNames from 'classnames'

const TeamNotesPanel = ({ contentInTextarea, isLoading, updatedBy, updatedAt, onContentChange, onTextareaFocus, onSaveChanges, onCancel, showButtons }) => (
  <Panel collapsible title='Team notes'>
    <TeamNotesMetadata
      updatedBy={updatedBy}
      updatedAt={updatedAt}
      isLoading={isLoading}
    />
    <Textarea
      class={classNames(
        'form-control',
        'team-notes__textarea',
        { 'is-loading': isLoading }
      )}
      placeholder='Leave a note to your moderation team'
      maxLength='1000'
      onContentChange={onContentChange}
      onTextareaFocus={onTextareaFocus}
      value={contentInTextarea}
    />
    {showButtons
      ? <TeamNotesButtons
        isLoading={isLoading}
        onSaveChanges={onSaveChanges}
        onCancel={onCancel}
      />
      : null
    }
  </Panel>
)

export default TeamNotesPanel
